import LoginCard from 'hb-builder/components/common/LoginCard';
import type { RenderProps } from 'hb-builder/components/common/type/RenderProps';
import UserBannerLayout from 'hb-builder/components/UIComponents/page/block/UserBanner/UserBannerLayout';
import {
  useRenderComponentsContext,
  useRendererContext,
} from 'hb-builder/hooks';
import type { RenderComponent } from 'hb-builder/types';
import { useGetUserInUserBanner } from 'hb-react/backoffice/requests/dynamicComponents/useGetUserInUserBanner';
import type { DocumentItem } from 'hb-react/backoffice/types/builder/builderDocument';
import type { SectionItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/sectionItemAttributes';

const CONTENT_TYPE = 'user';

const UserBanner: RenderComponent = () => <div />; // never used

const Render = ({ item }: RenderProps<DocumentItem<SectionItemAttributes>>) => {
  const { bodyWidth, isMobilePreview, isPublic, workspaceConfig } =
    useRendererContext();
  const { components } = useRenderComponentsContext();
  const { Section } = components;
  const { data: userData, isLoading } = useGetUserInUserBanner({
    enabled: !isPublic,
  });

  if (isPublic) {
    return <LoginCard componentName={CONTENT_TYPE} iconName="users" />;
  }

  return (
    <Section.Render
      bodyWidth={bodyWidth}
      item={item}
      isMobilePreview={isMobilePreview}
      workspaceConfig={workspaceConfig}
    >
      <UserBannerLayout isLoading={isLoading} item={item} user={userData} />
    </Section.Render>
  );
};

UserBanner.componentName = 'UserBanner';
UserBanner.Render = Render;

export default UserBanner;
